import { EventInfoProvider } from './../../providers/event-info/event-info';
import { DocumentsProvider } from './../../providers/documents/documents';
import { GeoFenceProvider } from './../../providers/geo-fence/geo-fence';
import { UserPosition } from './../../models/user.model';
import { Component, Input } from '@angular/core';
import {
    ModalController,
    NavController,
    NavParams,
    App,
    PopoverController,
    ToastController,
    Platform,
    LoadingController,
} from 'ionic-angular';
import { Post, SingleComment } from '../../models/post.model';
import { EventWallProvider } from '../../providers/event-wall/event-wall';
import { ToastHelper } from '../../helpers/toastr-helper';
import { File } from '@ionic-native/file';
import { HttpClient } from '@angular/common/http';
import { DocumentViewer, DocumentViewerOptions } from '@ionic-native/document-viewer/ngx';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { LoaderHelper } from '../../helpers/loader-helper';
import { FileOpener } from '@ionic-native/file-opener';
import { User } from '../../providers/user/user';
import {SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { AnalyticsProvider } from '../../providers/analytics/analytics';
import { MyEventsProvider } from '../../providers/my-events/my-events';

@Component({
    selector: 'event-wall',
    templateUrl: 'event-wall.html',
})
export class EventWallComponent {
    @Input()
    data: Post = new Post();
    @Input()
    postType: string = 'USER';
    @Input() disableNavigation: boolean;
    @Input() commentsCount: number;
    @Input() isSinglePost: boolean;
    text: string;
    topQuestions: SingleComment[];
    userLocation: UserPosition = new UserPosition();
    isUserAddmin: boolean;

    constructor(
        public app: App,
        public popoverCtrl: PopoverController,
        public navCtrl: NavController,
        public navParams: NavParams,
        public modalCtrl: ModalController,
        private geoFenceProvider: GeoFenceProvider,
        private eventWallProvider: EventWallProvider,
        private toastCtrl: ToastController,
        public http: HttpClient,
        private documentsProvider: DocumentsProvider,
        private document: DocumentViewer,
        private file: File,
        public platform: Platform,
        private androidPermissions: AndroidPermissions,
        public loadingCtrl: LoadingController,
        private fileOpener: FileOpener,
        private eventInfoProvider: EventInfoProvider,
        private userProvider: User,
        public sanitizer: DomSanitizer,
        private analyticsProvider: AnalyticsProvider,
    ) {
        this.text = 'Hello World';
    }

    async ngOnInit() {
        let elem = this.eventInfoProvider.adminEventList.find(e => e.uuid == this.data.eventUuid);
        this.isUserAddmin = !!elem;
    }

    showVideoUrl(url: string) {
        // Appending an ID to a YouTube URL is safe.
        // Always make sure to construct SafeValue objects as
        // close as possible to the input data, so
        // that it's easier to check if the value is safe.
        //https://www.youtube.com/watch?v=vKRKDhvbDDo
        let dangerousVideoUrl = 'https://www.youtube.com/embed/d06gXPJbaPs';
        return this.sanitizer.bypassSecurityTrustResourceUrl(dangerousVideoUrl);
    }

    like(eventId, postId, like): void {
        if (this.data.likedByMe) {
            this.eventWallProvider
                .likeOrUnlike(this.data.eventUuid, postId, false)
                .subscribe(res => {
                    this.data.likesCount = this.data.likesCount - 1;
                    this.data.likedByMe = false;
                });
        } else {
            this.eventWallProvider
                .likeOrUnlike(eventId, postId, true)
                .subscribe(res => {
                    this.data.likesCount = this.data.likesCount + 1;
                    this.data.likedByMe = true;
                },
                    response => {
                        ToastHelper.Show(this.toastCtrl, "You can not post if you are not physically on event. Please turn on your location and try again");
                    });
        }
    }

    addComment() {
      this.app.getRootNav().push('EventWallCommentPage', {
            post: this.data,
        });
    }

    goPost() {
      if (!this.disableNavigation) {
        this.app.getRootNav().push('EventWallPostPage', {
            postId: this.data.id,
            post: this.data,
        });
      }
    }

    addQuestion() {
      this.app.getRootNav().push('EventWallQaPage', {
            post: this.data,
        });
    }

    goVoting(data) {
        this.getLocation();
        this.app.getRootNav().push('EventWallVotingPage', {
            data: data,
        });
    }

    presentPopover(myEvent, eventId, postId, postType, pinned, postDetails) {
        let popover = this.popoverCtrl.create('PostPopoverPage', {
            id: postId,
            eventId: eventId,
            postType: postType,
            isUserAdmin: this.isUserAddmin,
            isPinned: pinned,
            postDetails: postDetails,
            userId: this.userProvider.currentUser().uuid
        });
        popover.present({
            ev: myEvent,
        });
    }

    getLocation() {
        this.geoFenceProvider.readAndSendLocation();
    }

    viewProfile(userId: string, eventId: string): void {
        if ( userId !== this.userProvider.currentUser().uuid) {
          this.app.getRootNav().push('ProfilePage', {
                userId: userId,
                event: eventId,
            });
        }
    }

    viewVideo(videoLink) {
        this.analyticsProvider.videoClickEvent(videoLink);
    }

    async downloadDocument(documentUrl: string, name: string) {
        this.analyticsProvider.documentClickEvent(name);
        LoaderHelper.Show(this.loadingCtrl);
        const formatName = name.replace(/[^\w\s]/gi, ' ');
        this.documentsProvider.downloadDocument(documentUrl).subscribe(response => {
            if (this.isNative()) {
                this.downloadFileNative(response, formatName);
            } else {
                this.downloadFile(response, formatName);
            }
        });
    }

    downloadFile(blob: any, name: string) {
        const url = window.URL.createObjectURL(blob);

        const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

        a.href = url;
        a.download = name;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        LoaderHelper.Hide();
    }

    async downloadFileNative(imageBlob: any, name: string) {
        this.androidPermissions.hasPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE)
            .then(async status => {
                if (status.hasPermission) {
                    await this.saveFile(imageBlob, name);
                }
                else {
                    this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE)
                        .then(async status => {
                            if (status.hasPermission) {
                                await this.saveFile(imageBlob, name);
                            }
                        });
                }
            });
    }

    async saveFile(imageBlob: any, name: string) {
        const androidDir = this.file.externalRootDirectory + 'Download/';
        const iosDir = this.file.documentsDirectory;
        console.log("File name: ", name);
        console.log("Data dir: ", this.isIOS() ? iosDir : androidDir);
        let response = await this.file.writeFile(this.isIOS() ? iosDir : androidDir, name + ".pdf", imageBlob, { replace: true });
        console.log(response);
        LoaderHelper.Hide();
        ToastHelper.Show(this.toastCtrl, "File saved to Download folder");
        this.fileOpener.open(response.nativeURL, 'application/pdf')
            .then(() => console.log('File is opened'))
            .catch(e => console.log('Error opening file', e));
    }

    isNative() {
        return this.platform.is('cordova');
    }

    isIOS() {
        return (this.platform.is('cordova') && this.platform.is('ios'));
    }

    async previewDocument(documentUrl: string, name: string) {
        this.documentsProvider.downloadDocument(documentUrl).subscribe(response => {
            this.previewFile(response, name);
        });
    }

    previewFile(blob: any, name: string) {
        const url = window.URL.createObjectURL(blob);

        location.href = url;
    }

}



// WEBPACK FOOTER //
// ./src/components/event-wall/event-wall.ts